{#if canAdminGeneral}
<Page contentAreaLayout="narrow">
    <PageHeader
        headingLevel="h1"
        title={i18n.courseDescription}
        backLinkText={i18n.backToOverview}
        backLinkUrl={courseUrl}
    />
    <div class="itsl-course-info-box itsl-course-info-box__edit-view">
        <CourseInfoBoxEditBanner
            {...i18n.banner}
            type={bannerType}
            bind:visible={showBanner}
        />
        <Form action="" name="itsl-course-info-box__edit-form">
            <TextField
                disabled={isFormLocked}
                height="medium"
                label={i18n.description}
                maxlength={1000}
                minlength={0}
                rows={10}
                type="area"
                bind:value={courseDescription}
            />

            <RadioGroup
                options={showTeachersOptions}
                name="showTeachers"
                id="show-teachers"
                label={i18n.showTeachers}
                bind:selected={showTeachers}
                useSmallRadioButtons={true}
            />

            <ButtonGroup>
                <Button
                    disabled={isFormLocked}
                    htmlType="submit"
                    large={true}
                    loading={isFormLocked}
                    text={i18n.save}
                    type="primary"
                    on:click={onFormSubmit}
                />
                <Button
                    disabled={isFormLocked}
                    htmlType="button"
                    large={true}
                    text={i18n.cancel}
                    type="secondary"
                    on:click={onFormCancel}
                />
            </ButtonGroup>
        </Form>
    </div>
</Page>
{/if}

<script>
    import { post } from "@itslearning/atlas/network/fetch";

    import Button from "@itslearning/prometheus/assets/inputs/Button/v1/Button.svelte";
    import ButtonGroup from "@itslearning/prometheus/assets/inputs/ButtonGroup/v1/ButtonGroup.svelte";
    import Form from "@itslearning/prometheus/assets/inputs/Form/v1/Form.svelte";
    import Page from "@itslearning/prometheus/assets/templates/Page/v1/Page.svelte";
    import PageHeader from "@itslearning/prometheus/assets/patterns/PageHeader/v1/PageHeader.svelte";
    import RadioGroup from "@itslearning/prometheus/assets/inputs/RadioGroup/v1/RadioGroup.svelte";
    import TextField from "@itslearning/prometheus/assets/inputs/TextField/v1/TextField.svelte";

    import CourseInfoBoxEditBanner from "./CourseInfoBoxEditBanner.svelte";

    export let antiForgeryHeaderName;
    export let antiForgeryHeaderValue;
    export let canAdminGeneral;
    export let courseDescription;
    export let courseUrl;
    export let i18n;
    export let showTeachers;
    export let updateCourseInfoBoxSettingsEndpointURL;

    let bannerType = "info";
    let isFormLocked = false;
    let showBanner = false;

    $: showTeachersOptions = [
        { label: i18n.yes, id: 1, value: true, disabled: isFormLocked },
        { label: i18n.no, id: 2, value: false, disabled: isFormLocked },
    ];

    const displayWarningBanner = () => {
        showBanner = true;
        bannerType = "warning";
    };

    const hideBanner = () => showBanner = false;

    const lockForm = () => isFormLocked = true;
    const unlockForm = () => isFormLocked = false;

    const onFormCancel = () => window.location.href = courseUrl;
    const onFormSubmit = () => {
        hideBanner();
        lockForm();
        post(
            updateCourseInfoBoxSettingsEndpointURL,
            { courseDescription, showTeachers },
            { headers: { [antiForgeryHeaderName]: antiForgeryHeaderValue }}
        ).then(() => {
            window.location.href = courseUrl;
        }).catch(() => {
            displayWarningBanner();
            unlockForm();
        });
    };
</script>
